import { addHours, endOfMonth, format, getMonth, startOfMonth } from 'date-fns';

export const getMonths = () => {
  let months = new Array(12).fill(0).map((_, i) => i);
  const current = getMonth(new Date());
  const curIndex = months.indexOf(current);
  months = months
    .slice(curIndex + 2)
    .concat(months.slice(0, curIndex + 1))
    .reverse();
  return months.map((m, i) => ({
    name: i === 0 ? 'This month' : i === 1 ? 'Last month' : format(new Date().setMonth(m), 'MMMM'),
    value: m,
    range: [addHours(startOfMonth(new Date().setMonth(m)), 12), addHours(endOfMonth(new Date().setMonth(m)), -12)],
  }));
};
